
/*
* 设置动态标题
* */

const title = "崖州湾科技城电子采购平台"
// const title = "电子采购测试环境"

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/utils/get-page-title.js